import zoomToExtentIcon from '@disy/cadenza-icons/zoom-to-extent.svg';

import { LayerProperty } from 'cadenza/map/layer-property';
import { fitMapViewToScaledExtent } from 'cadenza/map/map-utils';
import { icon } from 'cadenza/utils/icon/icon';
import { getAndUpdateLayerSuggestedExtent } from 'cadenza/map/layer-utils';

import { LayerAction } from './layer-action';
import i18n from './layer-actions.properties';

export class ZoomToExtent extends LayerAction {

  #map;
  #inProgress = false;
  #cancelled = false;

  constructor (layer, { map, label = i18n('mapConfig.layerZoomToExtent') } = {  }) {
    super(layer, { label, icon: icon(zoomToExtentIcon) });
    this.#map = map;
    this.#map.on('movestart', () => {
      if (this.#inProgress && !this.#cancelled) {
        this.cancel();
      }
    });
  }

  isCancellable () {
    return true;
  }

  isCancelled () {
    return this.#cancelled;
  }

  cancel () {
    this.#cancelled = true;
    this.dispatchEvent('cancelled');
  }

  execute () {
    this.#inProgress = true;
    this.#cancelled = false;
    return this.getExtent().then(extent => {
      this.#inProgress = false;
      if (!this.#cancelled && extent) {
        return fitMapViewToScaledExtent(this.#map, extent);
      }
    });
  }

  /**
   * Gets the extent to zoom to.
   *
   * @return {Promise<Array>} the extent to zoom to
   * @protected
   */
  getExtent () {
    const suggestedExtent = this.layer.get(LayerProperty.SUGGESTED_EXTENT);
    if (suggestedExtent) {
      return Promise.resolve(suggestedExtent);
    }
    return getAndUpdateLayerSuggestedExtent(this.layer, this.#map);
  }

  isSupportedSync () {
    return this.layer.get(LayerProperty.SUGGESTED_EXTENT) || this.layer.get(LayerProperty.IS_SELECTOR_LAYER);
  }

}
